import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Backdrop from "@material-ui/core/Backdrop";
import Paper from "@material-ui/core/Paper";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import ApiService from "../../ApiService";
import SearchIcon from "@material-ui/icons/Search";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import DoneIcon from "@material-ui/icons/Done";
import Divider from "@material-ui/core/Divider";
import EditIcon from "@material-ui/icons/Edit";
import MaterialTable from "../../components/MaterialTable";
import TablePagination from "@material-ui/core/TablePagination";
import DateFnsUtils from "@date-io/date-fns";
import { /* subMonths, */ subDays, format } from "date-fns";
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";

import { Alert, Autocomplete, accordionDetailsClasses } from "@mui/material";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "@material-ui/core/Input";
import Box from "@material-ui/core/Box";
import ReverseIcon from "@material-ui/icons/SettingsBackupRestore";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import CustomTooltip from "../../components/Custom/Tooltip/Tooltip";

import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
} from "@material-ui/pickers";
import Button from "../../components/Custom/Button/Button";
import { Button as MTButton, ButtonGroup } from "@mui/material";
import GridItem from "../../components/Custom/Grid/GridItem";
import GridContainer from "../../components/Custom/Grid/GridContainer";
import {
  DialogActions,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  tablewraptext: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  small: {
    width: theme.spacing(7),
    height: theme.spacing(4),
  },
  medium: {
    width: "45px",
    height: "15px",
  },
  chipRoot: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  searchbar: {
    margin: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: "absolute",
    marginTop: 8,
    marginLeft: -65,
  },
  crossError: {
    color: theme.palette.error.main,
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
  },
  formControl1: {
    minWidth: 150,
    maxWidth: 300,
  },
  menuText: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  buttonGroup: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  button: {
    margin: theme.spacing(1),
  },
});

class MerchantTransactionsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      result: [],
      merchantId: null,
      message: null,
      fromDate: subDays(new Date(), 20),
      toDate: new Date(),
      fromTime: new Date().setHours(0, 0, 0),
      toTime: new Date().setHours(23, 59, 59),
      order: "desc",
      orderBy: "Date",
      loading: false,
      statusCriteria: ["ALL"],
      orderNoCriteria: null,
      email: null,
      merchantTerminals: null,
      terminalId: null,
      failed: false,
      success: false,
      successMessage: null,
      refundReason: "",
      disputeInitiator: "",
      disputeInfo: "",
      refundPanelVisible: false,
      disputePanelVisible: false,
      refundAmount: 0.0,
      disputeAmount: 0.0,
      refundTxnId: null,
      disputeTxnId: null,
      criteriaTxnId: null,
      acquirerTxnId: null,
      txnUpdatePanelVisible: false,
      targetStatus: null,
      gatewayResponseTrackerId: null,
      transactionInfo: null,
      signInfo: null,
      billingDescriptor: null,
      numberRowPerPage: 20,
      totalRow: 0,
      pageNumber: 0,
      rowsPerPageOptions: [100, 200, 300],
      allChbk: false,
      allDispute: false,
      showDateMsg: true,
      verifying: false,
      acquirerAccountId: [],
      acquirerAccId: null,
      acquirerAccounts: [],
      accountPoolIdList: [],
      accountPoolId: null,
      accountPoolIdNew: null,
      label: null,

      disputeStatus: "",
      evidenceType: null,
      rejectReason: null,
      files: [],
      resMsg: null,
      failed3: false,
      disputeId: null,
      merchants: [],
      selectedMerchant: null,
      terminals: [],
      responsemessage2: null,
      failed2: false,
      success2: false,
    };
    this.reloadTransactions = this.reloadTransactions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleStatusSelectChange = this.handleStatusSelectChange.bind(this);
    this.handleOrderNoChange = this.handleOrderNoChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.searchTransactions = this.searchTransactions.bind(this);
    this.refundTransaction = this.refundTransaction.bind(this);
    this.hideRefundPanel = this.hideRefundPanel.bind(this);
    this.hideDisputePanel = this.hideDisputePanel.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.showTxnUpdatePanel = this.showTxnUpdatePanel.bind(this);
    this.hideTxnUpdatePanel = this.hideTxnUpdatePanel.bind(this);
    this.handleTargetStatusSelectChange =
      this.handleTargetStatusSelectChange.bind(this);
    this.changeTransactionStatus = this.changeTransactionStatus.bind(this);
    this.handleChangeRowPerPage = this.handleChangeRowPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.verifyTransactionStatus = this.verifyTransactionStatus.bind(this);
    this.handleChbk = this.handleChbk.bind(this);
    this.handleDispute = this.handleDispute.bind(this);
  }
  componentDidMount() {
    /* { this.reloadTransactions()} */
    // this.fetchMerchantTerminals();
    this.fetchAcquirerAccounts();
    this.fetchAllMerchants();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.success2 && prevState.success2 !== this.state.success2) {
      this.clearMessage();
    }
    if (this.state.failed2 && prevState.failed2 !== this.state.failed2) {
      this.clearMessage();
    }
  }
  clearMessage = () => {
    setTimeout(() => {
      this.setState({
        success2: false,
        failed2: false,
        responsemessage2: null,
      });
    }, 3000);
  };

  fetchAllMerchants = () => {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  };

  onMerchantChange = (event, newValue) => {
    let selMercht = newValue ? newValue : null;
    if (selMercht) {
      this.setState({
        selectedMerchant: selMercht,
      });
    } else {
      this.setState({
        terminals: [],
        selectedMerchant: null,
        label: null,
      });
    }

    this.showTerminalsById(selMercht ? selMercht.id : null);
  };

  showTerminalsById(merchantId) {
    if (merchantId || merchantId !== null) {
      ApiService.fetchMerchantTerminalsByMerId(merchantId)
        .then((res) => {
          this.setState({ terminals: res.data });
        })
        .catch((e) => {});
    }
  }
  hideRefundPanel() {
    this.setState({ refundPanelVisible: false });
  }
  hideDisputePanel() {
    this.setState({ disputePanelVisible: false });
  }
  hideTxnUpdatePanel() {
    this.setState({
      txnUpdatePanelVisible: false,
      failed2: false,
      targetStatus: null,
      gatewayResponseTrackerId: null,
      transactionInfo: null,
      signInfo: null,
      billingDescriptor: null,
      accountPoolIdNew: null,
      acquirerAccId: null,
    });
  }
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  // handleTerminalIdChange = (event) => {
  //   this.handleChange(event);
  //   this.setState({
  //     acquirerAccountId: [],
  //     accountPoolId: null,
  //     acquirerAccounts: [],
  //   });
  // };

  handleTerminalIdChange = (event, newValue) => {
    if (newValue) {
      this.setState({
        terminalId: newValue.terminalId,
        label: newValue.label,
        acquirerAccountId: [],
        accountPoolId: null,
        acquirerAccounts: [],
      });
    } else {
      this.setState({
        label: null,
        terminalId: null,
      });
      this.fetchAcquirerAccounts();
    }
  };

  // handleAcquirerAccountChange = (event) => {
  //   if (event.target && event.target.value) {
  //     this.setState({
  //       acquirerAccountId: event.target.value,
  //       terminalId: null,
  //     });
  //   }
  // };

  handleAcquirerAccountChange = (event, newValue) => {
    if (newValue) {
      this.setState({
        acquirerAccountId: newValue,
        terminalId: null,
        selectedMerchant: null,
      });
    } else {
      this.setState({
        acquirerAccountId: [],
      });
    }
  };

  handleAcquirerAccountChange2 = (event, newValue) => {
    if (newValue) {
      this.setState({
        acquirerAccId: newValue,
      });
    } else {
      this.setState({
        acquirerAccId: null,
      });
    }
  };

  handleAccountPoolChange = (event) => {
    this.setState({
      accountPoolId: event.target.value,
      terminalId: null,
      acquirerAccountId: [],
    });

    this.fetchAcquirerAccountsWithPool(event.target.value);
  };

  handleAccountPoolChangeNew = (event) => {
    this.setState({
      accountPoolIdNew: event.target.value,
    });

    this.fetchAcquirerAccountsWithPool(event.target.value);
  };

  fetchAcquirerAccountsWithPool = (accountPoolId) => {
    ApiService.fetchAcquirerAccountsWithPoolId(accountPoolId)
      .then((res) => {
        this.setState({ acquirerAccounts: res.data });
      })
      .catch((e) => {});
  };

  fetchAcquirerAccounts = () => {
    ApiService.fetchAcquirerAccounts()
      .then((res) => {
        this.setState({ acquirerAccounts: res.data });
        const poolIdArray = [];
        res.data.forEach((x) => {
          if (x.accountPoolId != null && !poolIdArray.includes(x.accountPoolId))
            poolIdArray.push(x.accountPoolId);
        });
        this.setState({ accountPoolIdList: poolIdArray });
      })
      .catch((e) => {});
  };

  getAcquirerAccountIdToSubmit = () => {
    const acqIds = [];
    this.state.acquirerAccountId.map((acqItem) =>
      acqIds.push(acqItem.acquirerAccountId)
    );
    return acqIds;
  };

  handleChangeRowPerPage(data) {}
  handleChbk() {
    if (this.state.allChbk === false) {
      this.setState({ allChbk: true, showDateMsg: false });
    } else {
      this.setState({ allChbk: false, showDateMsg: true });
    }
  }

  handleDispute() {
    if (this.state.allDispute === false) {
      this.setState({ allDispute: true, showDateMsg: false });
    } else {
      this.setState({ allDispute: false, showDateMsg: true });
    }
  }

  handleChangePage(e, pageNo) {
    this.setState({ pageNumber: pageNo });
    this.reloadTransactions(pageNo);
  }
  reloadTransactions(pageNo) {
    this.setState({ loading: true });
    const acqIds = this.getAcquirerAccountIdToSubmit();
    ApiService.fetchMerchantTransactions(
      format(this.state.fromDate, "yyyyMMdd"),
      format(this.state.toDate, "yyyyMMdd"),
      format(this.state.fromTime, "HH:mm:ss"),
      format(this.state.toTime, "HH:mm:ss"),
      this.state.statusCriteria,
      this.state.orderNoCriteria,
      this.state.email,
      this.state.terminalId,
      this.state.acquirerTxnId,
      this.state.criteriaTxnId,
      pageNo,
      this.state.accountPoolId,
      acqIds,
      this.state.numberRowPerPage,
      this.state.allChbk
    )
      .then((res) => {
        this.setState({
          totalRow: res.data.totalRow,
          result: res.data.transactions,
          merchantId: res.data.merchantId,
          loading: false,
          failed: false,
        });
      })
      .catch((e) => {});
  }

  searchTransactions() {
    this.setState({ pageNumber: 0 });

    // Destructure state for readability (optional but recommended)
    const {
      terminalId,
      criteriaTxnId,
      acquirerTxnId,
      accountPoolId,
      acquirerAccountId,
      orderNoCriteria, // Include the new state variable
    } = this.state;

    if (
      terminalId === null &&
      criteriaTxnId === null &&
      acquirerTxnId === null &&
      accountPoolId === null &&
      acquirerAccountId.length < 1 &&
      (orderNoCriteria === null || orderNoCriteria.trim() === "") // <-- Added check here
    ) {
      this.setState({
        responsemessage:
          "Please provide at least one search criterion (e.g., Terminal, Txn ID, Acquirer Txn ID, Account Pool, Acquirer Account, Order No).", // <-- Updated message
        failed: true,
      });
      return; // Stop execution if no criteria are provided
    }

    this.reloadTransactions(0);
  }
  handleStatusSelectChange(event) {
    this.setState({ statusCriteria: event.target.value });
  }
  handleTargetStatusSelectChange(event) {
    this.setState({ targetStatus: event.target.value });
  }
  handleOrderNoChange(event) {
    this.setState({ orderNoCriteria: event.target.value });
  }
  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }
  handleClose() {
    this.setState({ loading: false });
  }

  showRefundPanel(txn) {
    this.setState({
      refundPanelVisible: true,
      refundAmount: txn.amount,
      refundTxnId: txn.merchantTransactionId,
    });
  }
  showDisputePanel(txn) {
    this.setState({
      disputePanelVisible: true,
      disputeAmount: txn.amount,
      disputeTxnId: txn.merchantTransactionId,
    });
  }

  showTxnUpdatePanel(txn) {
    this.setState({
      txnUpdatePanelVisible: true,
      refundTxnId: txn.merchantTransactionId,
    });
  }
  refundTransaction() {
    this.setState({ loading: true });
    ApiService.refundMerchantTransaction(
      this.state.refundTxnId,
      this.state.refundReason,
      this.state.refundAmount
    )
      .then((res) => {
        if (res.data.status === "SUCCESS")
          this.setState({
            responsemessage: "Refund initiated successfully",
            success: true,
            failed: false,
          });
        else
          this.setState({
            responsemessage: "Refund request failed",
            success: false,
            failed: true,
          });

        this.reloadTransactions(this.state.pageNumber);
      })
      .catch((e) => {
        this.setState({
          responsemessage: "Error refunding transaction " + e,
          success: false,
          failed: true,
        });
      });
    this.setState({
      refundPanelVisible: false,
      refundAmount: 0.0,
      refundTxnId: null,
    });
  }

  disputeTransaction = () => {
    this.setState({ loading: true });
    ApiService.reportDisputeTransaction(
      this.state.disputeTxnId,
      this.state.disputeInitiator,
      this.state.disputeInfo,

      this.state.disputeAmount
    )
      .then((res) => {
        if (res.data.status === "OK") {
          this.setState({
            responsemessage: res.data.responseMessage,
            success: true,
            failed: false,
            loading: false,
          });
        } else {
          this.setState({
            responsemessage: res.data.responseMessage,
            success: false,
            failed: true,
            loading: false,
          });
        }
        setTimeout(() => {
          this.reloadTransactions(this.state.pageNumber);
        }, 1000);
      })
      .catch((e) => {
        this.setState({
          responsemessage: "Error in Dispute transaction " + e,
          success: false,
          failed: true,
          loading: false,
        });
      });
    this.setState({
      disputePanelVisible: false,
      disputeAmount: 0.0,
      disputeTxnId: null,
      disputeInitiator: "",
      disputeInfo: "",
    });
  };

  changeTransactionStatus() {
    if (this.state.targetStatus === null) {
      this.setState({
        failed2: true,
        responsemessage2: "Please select target status",
      });
    } else {
      ApiService.changeTransactionStatus(
        this.state.refundTxnId,
        this.state.targetStatus,
        this.state.gatewayResponseTrackerId,
        this.state.transactionInfo,
        this.state.signInfo,
        this.state.billingDescriptor,
        this.state.acquirerAccId && this.state.acquirerAccId.acquirerAccountId
      )
        .then((res) => {
          if (res.data.status === "OK") {
            this.setState({
              responsemessage: res.data.responseMessage,
              success: true,
              failed: false,
              failed2: false,
              txnUpdatePanelVisible: false,
              targetStatus: null,
              accountPoolIdNew: null,
              acquirerAccId: null,
              gatewayResponseTrackerId: null,
              transactionInfo: null,
              signInfo: null,
              billingDescriptor: null,
            });
            this.reloadTransactions(this.state.pageNumber);
          } else
            this.setState({
              responsemessage: res.data.responseMessage,
              success: false,
              failed: true,
              txnUpdatePanelVisible: false,
              targetStatus: null,
              accountPoolIdNew: null,
              acquirerAccId: null,
              gatewayResponseTrackerId: null,
              transactionInfo: null,
              signInfo: null,
              billingDescriptor: null,
            });
        })
        .catch((e) => {
          this.setState({
            responsemessage: "Error changing transaction status" + e,
            success: false,
            failed: true,
            txnUpdatePanelVisible: false,
            targetStatus: null,
            accountPoolIdNew: null,
            acquirerAccId: null,
            gatewayResponseTrackerId: null,
            transactionInfo: null,
            signInfo: null,
            billingDescriptor: null,
          });
        });
    }
  }

  verifyTransactionStatus(txn) {
    if (this.state.verifying === true) {
      return;
    }
    this.setState({ verifying: true });
    ApiService.verifyAndCorrectTransactionStatus(
      txn.merchantTransactionId
    ).then((res) => {
      if (res.data && res.data.status === "OK") {
        this.setState({
          responsemessage: res.data.responseMessage,
          success: true,
          failed: false,
        });
        this.reloadTransactions(this.state.pageNumber);
        this.setState({ verifying: false });
      } else {
        this.setState({
          responsemessage: res.data.responseMessage,
          success: false,
          failed: true,
          verifying: false,
        });
      }
    });
  }

  headCells = [
    {
      id: "Terminal_Id",
      numeric: false,
      disablePadding: false,
      label: "Terminal Id",
    },
    { id: "Date", numeric: false, disablePadding: false, label: "Date" },
    { id: "Txn_Id", numeric: false, disablePadding: false, label: "Txn Id" },
    {
      id: "Acq_Txn_Id",
      numeric: false,
      disablePadding: false,
      label: "Acq Txn Id",
    },
    { id: "Type", numeric: false, disablePadding: false, label: "Type" },
    { id: "Status", numeric: false, disablePadding: false, label: "Status" },
    { id: "Amount", numeric: true, disablePadding: false, label: "Amount" },
    {
      id: "Currency",
      numeric: false,
      disablePadding: false,
      label: "Currency",
    },
  ];
  headCells2 = [
    { id: "Date", numeric: false, disablePadding: false, label: "Date" },
    { id: "Status", numeric: false, disablePadding: false, label: "Status" },
  ];
  headCells3 = [
    {
      id: "Captured",
      numeric: false,
      disablePadding: false,
      label: "Captured amnt",
    },
    {
      id: "ChargBck",
      numeric: false,
      disablePadding: false,
      label: "Chargeback amnt",
    },
    {
      id: "gatewayResponse",
      numeric: false,
      disablePadding: false,
      label: "Billing desc",
    },
    {
      id: "gatewayResponse",
      numeric: false,
      disablePadding: false,
      label: "TrackerId",
    },
    { id: "txnInfo", numeric: false, disablePadding: false, label: "Txn Info" },
    {
      id: "gatewayResponse",
      numeric: false,
      disablePadding: false,
      label: "SignInfo",
    },
  ];
  ITEM_HEIGHT = 50;
  ITEM_PADDING_TOP = 8;
  MenuProps = {
    PaperProps: {
      style: {
        maxHeight: this.ITEM_HEIGHT * 4.5 + this.ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  TerminalMenuProps = {
    PaperProps: {
      style: {
        maxHeight: this.ITEM_HEIGHT * 5.5 + this.ITEM_PADDING_TOP,
        width: 500,
      },
    },
  };
  tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  render() {
    const { classes } = this.props;
    const {
      terminalId,
      merchantTerminals,
      accountPoolIdList,
      accountPoolId,
      acquirerAccounts,
      acquirerAccountId,
      disputeInfo,

      disputeStatus,
      evidenceType,
      rejectReason,
      resMsg,
      failed3,
      files,
    } = this.state;
    return (
      <React.Fragment>
        <Paper style={{ margin: "1em", padding: "1em" }}>
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            Merchant Transactions
          </Typography>
          {this.state.failed && (
            <Alert severity="error" elevation={0}>
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}
          {this.state.success && (
            <Alert severity="success" elevation={0}>
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}

          <Divider light className={classes.searchbar} />
          <GridContainer spacing={2} style={{ margin: ".1em" }}>
            {" "}
            {/* Added spacing prop */}
            {/* Date/Time Pickers */}
            <GridItem xs={12} sm={6} md={3} lg={2}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  autoOk
                  label="From"
                  format="MM/dd/yyyy"
                  value={this.state.fromDate}
                  onChange={(val) => this.setState({ fromDate: val })}
                  fullWidth // Ensures it fills the GridItem
                />
              </MuiPickersUtilsProvider>
            </GridItem>
            <GridItem xs={12} sm={6} md={3} lg={2}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  label="From Time"
                  views={["hours", "minutes", "seconds"]}
                  value={this.state.fromTime}
                  format="HH:mm:ss"
                  onChange={(val) => this.setState({ fromTime: val })}
                  fullWidth // Ensures it fills the GridItem
                />
              </MuiPickersUtilsProvider>
            </GridItem>
            <GridItem xs={12} sm={6} md={3} lg={2}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  autoOk
                  label="To"
                  format="MM/dd/yyyy"
                  value={this.state.toDate}
                  onChange={(val) => this.setState({ toDate: val })}
                  fullWidth // Ensures it fills the GridItem
                />
              </MuiPickersUtilsProvider>
            </GridItem>
            <GridItem xs={12} sm={6} md={3} lg={2}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  label="To Time"
                  views={["hours", "minutes", "seconds"]}
                  value={this.state.toTime}
                  format="HH:mm:ss"
                  onChange={(val) => this.setState({ toTime: val })}
                  fullWidth // Ensures it fills the GridItem
                />
              </MuiPickersUtilsProvider>
            </GridItem>
            {/* Merchant Autocomplete */}
            <GridItem xs={12} sm={6} md={4} lg={3}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <FormControl fullWidth className={classes.formControlList}>
                {" "}
                {/* Use fullWidth */}
                <Autocomplete
                  value={this.state.selectedMerchant}
                  onChange={this.onMerchantChange}
                  options={this.state.merchants}
                  getOptionLabel={(option) =>
                    option ? option.merchantName + "-" + option.code : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // labelId="merchantSelectLabel" // Not needed for Autocomplete TextField
                      label="Merchants"
                    />
                  )}
                />
              </FormControl>
            </GridItem>
            {/* Terminal Autocomplete */}
            <GridItem xs={12} sm={6} md={4} lg={3}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <FormControl fullWidth className={classes.formControlList}>
                {" "}
                {/* Use fullWidth */}
                <Autocomplete
                  value={this.state.label}
                  id="merchantTerminalSelectLabel"
                  onChange={this.handleTerminalIdChange}
                  options={this.state.terminals}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.terminalId}>
                        {option.label + "-" + option.terminalCardType}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Terminals" />
                  )}
                />
              </FormControl>
            </GridItem>
            {/* Status Select */}
            <GridItem xs={12} sm={6} md={4} lg={3}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <FormControl fullWidth className={classes.formControl}>
                {" "}
                {/* Use fullWidth */}
                <InputLabel id="statusSelectLabel">Status</InputLabel>
                <Select
                  multiple
                  value={this.state.statusCriteria}
                  MenuProps={this.MenuProps}
                  onChange={this.handleStatusSelectChange}
                  labelId="statusSelectLabel"
                  id="statusSelect"
                  label="Status" // Add label prop for consistency
                >
                  <MenuItem
                    key={"SALE_SUCCESSFUL"}
                    value={"SALE_SUCCESSFUL"}
                    dense
                  >
                    SALE_SUCCESSFUL
                  </MenuItem>
                  <MenuItem key={"SALE_FAILED"} value={"SALE_FAILED"} dense>
                    SALE_FAILED
                  </MenuItem>
                  <MenuItem key={"SALE_PENDING"} value={"SALE_PENDING"} dense>
                    SALE_PENDING
                  </MenuItem>
                  <MenuItem
                    key={"REFUND_SUCCESSFUL"}
                    value={"REFUND_SUCCESSFUL"}
                    dense
                  >
                    REFUND_SUCCESSFUL
                  </MenuItem>
                  <MenuItem key={"REFUND_FAILED"} value={"REFUND_FAILED"} dense>
                    REFUND_FAILED
                  </MenuItem>
                  <MenuItem key={"CHARGEBACK"} value={"CHARGEBACK"} dense>
                    CHARGEBACK
                  </MenuItem>
                  <MenuItem key={"SETTLED"} value={"SETTLED"} dense>
                    SETTLED
                  </MenuItem>
                  <MenuItem key={"ALL"} value={"ALL"} dense>
                    ALL
                  </MenuItem>
                </Select>
              </FormControl>
            </GridItem>
            {/* Account Pool Select */}
            <GridItem xs={12} sm={6} md={4} lg={3}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <FormControl fullWidth className={classes.formControl}>
                {" "}
                {/* Use fullWidth */}
                <InputLabel id="poolSelectLabel">Account Pool</InputLabel>
                <Select
                  value={this.state.accountPoolId}
                  MenuProps={this.MenuProps}
                  onChange={this.handleAccountPoolChange}
                  name="accountPoolId"
                  labelId="poolSelectLabel"
                  id="accountPoolIdSelect"
                  label="Account Pool" // Add label prop for consistency
                >
                  <MenuItem key="" value={null}>
                    {" "}
                  </MenuItem>
                  {this.state.accountPoolIdList &&
                    this.state.accountPoolIdList.map((pool) => (
                      <MenuItem key={pool} value={pool} dense>
                        {pool}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </GridItem>
            {/* Acquirer Account Autocomplete - Wrapped in GridItem */}
            <GridItem xs={12} md={8} lg={6}>
              {" "}
              {/* Adjusted breakpoints, removed style, wrapped the FormControl */}
              <FormControl fullWidth>
                {" "}
                {/* Use fullWidth, removed specific style */}
                <Autocomplete
                  multiple
                  value={this.state.acquirerAccountId} // Use state value
                  onChange={this.handleAcquirerAccountChange}
                  options={this.state.acquirerAccounts} // Use state options
                  getOptionLabel={(option) =>
                    option
                      ? `${option.mid}-${option.accountNumber}-${option.userName}-${option.cardType?.type}`
                      : ""
                  }
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Acquirer Account"
                      placeholder="Acquirer Account" // Placeholder can be useful for multi-select
                    />
                  )}
                />
              </FormControl>
            </GridItem>
            {/* Text Fields */}
            <GridItem xs={12} sm={6} md={4} lg={3}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <TextField
                id="orderNo"
                label="Order Number"
                value={this.state.orderNo} // Controlled component
                onChange={this.handleOrderNoChange}
                fullWidth // Use fullWidth
                className={classes.formControl}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={3}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <TextField
                id="email"
                label="Customer email"
                value={this.state.email} // Controlled component
                onChange={this.handleEmailChange}
                fullWidth // Use fullWidth
                className={classes.formControl}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={3}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <TextField
                id="criteriaTxnId"
                name="criteriaTxnId"
                label="Transaction Id"
                value={this.state.criteriaTxnId} // Controlled component
                onChange={this.handleChange}
                fullWidth // Use fullWidth
                className={classes.formControl}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={3}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <TextField
                id="acqTxnId"
                name="acquirerTxnId"
                label="Acquirer transaction Id"
                value={this.state.acquirerTxnId} // Controlled component
                onChange={this.handleChange}
                fullWidth // Use fullWidth
                className={classes.formControl}
              />
            </GridItem>
            {/* Checkboxes */}
            <GridItem xs={6} sm={4} md={3} lg={2}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <FormControlLabel
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  paddingTop: "8px",
                }} // Align checkbox+label better within the item
                control={
                  <Checkbox
                    checked={this.state.allChbk}
                    onChange={this.handleChbk}
                    name="allChbk"
                  />
                }
                label="Chargebacks"
              />
            </GridItem>
            <GridItem xs={6} sm={4} md={3} lg={2}>
              {" "}
              {/* Adjusted breakpoints, removed style */}
              <FormControlLabel
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  paddingTop: "8px",
                }} // Align checkbox+label better within the item
                control={
                  <Checkbox
                    checked={this.state.allDispute}
                    onChange={this.handleDispute}
                    name="allDispute"
                  />
                }
                label="Disputes"
              />
            </GridItem>
            {/* Search Button Area */}
            <GridItem xs={12} style={{ marginTop: "1em" }}>
              {" "}
              {/* Keep full width and add margin top for separation */}
              {this.state.showDateMsg && (
                <div>
                  <Typography noWrap={true} variant="caption">
                    (Dates max 1 month apart)
                  </Typography>
                </div>
              )}
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                startIcon={<SearchIcon />}
                onClick={this.searchTransactions}
              >
                Search
              </Button>
              <Backdrop
                open={this.state.loading}
                className={classes.backdrop} // Use class for styling
                onClick={this.handleClose} // Consider if closing on click is desired
                sx={{
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                  color: "#fff",
                }} // sx prop for easy styling overrides
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </GridItem>
          </GridContainer>
          <GridContainer style={{ margin: ".1em" }}>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ marginTop: "4px" }}
            >
              <MaterialTable
                title=""
                icons={this.tableIcons}
                components={{
                  Pagination: (props) => (
                    <TablePagination
                      {...props}
                      rowsPerPageOptions={[]}
                      rowsPerPage={this.state.numberRowPerPage}
                      count={this.state.totalRow}
                      page={this.state.pageNumber}
                      onChangePage={(e, page) => this.handleChangePage(e, page)}
                      onRowsPerPageChange={(event) => {
                        //props.onChangeRowsPerPage(event);
                        this.handleChangeRowPerPage(event.target.value);
                      }}
                    />
                  ),
                }}
                columns={[
                  {
                    field: "terminalId",
                    title: "Terminal",
                    render: (rowData) => (
                      <CustomTooltip title={rowData.terminalId} copy={true}>
                        <InfoOutlinedIcon />
                      </CustomTooltip>
                    ),
                  },
                  {
                    field: "createdDisplay",
                    title: "Date",
                    type: "date",
                    render: (rowData) => (
                      <Typography noWrap="true" variant="caption">
                        {rowData.createdDisplay}
                      </Typography>
                    ),
                  },
                  {
                    field: "merchantTransactionId",
                    title: "Txn Id",
                    render: (rowData) => (
                      <CustomTooltip
                        title={rowData.merchantTransactionId}
                        copy={true}
                      >
                        <InfoOutlinedIcon />
                      </CustomTooltip>
                    ),
                  },

                  {
                    field: "gatewayResponseTrackerId",
                    title: "Acq Txn Id",
                    render: (rowData) => (
                      <CustomTooltip
                        title={rowData.gatewayResponseTrackerId}
                        copy={true}
                      >
                        <InfoOutlinedIcon />
                      </CustomTooltip>
                    ),
                  },
                  {
                    field: "merchantOrderNo",
                    title: "Ord No",
                    render: (rowData) => (
                      <CustomTooltip
                        title={rowData.merchantOrderNo}
                        copy={true}
                      >
                        <InfoOutlinedIcon />
                      </CustomTooltip>
                    ),
                  },
                  {
                    field: "transactionType",
                    title: "Pay Method",
                    render: (rowData) => (
                      <Typography variant="caption">
                        {rowData.transactionType != null &&
                          rowData.transactionType === "SALE" &&
                          "CC"}
                        {rowData.transactionType != null &&
                          rowData.transactionType === "REFUND" &&
                          "CC"}
                        {rowData.transactionType != null &&
                          rowData.transactionType === "CHECKOUT" &&
                          "Other"}
                      </Typography>
                    ),
                  },
                  {
                    field: "cardType",
                    title: "Type",
                    cellStyle: { fontSize: 11, fontFamily: "sans-serif" },
                  },
                  {
                    field: "statuses[0].transactionStatus",
                    title: "Status",
                    cellStyle: { fontSize: 11, fontFamily: "sans-serif" },
                  },
                  {
                    field: "amount",
                    title: "Amount",
                    type: "numeric",
                    render: (rowData) => (
                      <Typography variant="caption">
                        {rowData.amount && rowData.amount.toFixed(2)}
                      </Typography>
                    ),
                  },
                  {
                    field: "currency",
                    title: "Currency",
                    cellStyle: { fontSize: 11, fontFamily: "sans-serif" },
                  },
                  {
                    field: "customerEmail",
                    title: "Cust Email",
                    cellStyle: { fontSize: 11, fontFamily: "sans-serif" },
                  },
                  {
                    field: "isSettled",
                    title: "Settled",
                    cellStyle: { fontSize: 11, fontFamily: "sans-serif" },
                  },
                  {
                    field: "refundAmount",
                    title: "Refund amt",
                    cellStyle: { fontSize: 11, fontFamily: "sans-serif" },
                  },
                ]}
                data={this.state.result}
                localization={{
                  toolbar: {
                    exportCSVName: "Export as XL",
                    exportPDFName: "Export as CSV",
                  },
                }}
                actions={[
                  (rowData) => ({
                    tooltip: "Verify transaction",
                    icon: (props) => (
                      <MTButton
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<DoneIcon {...props} />}
                        disabled={
                          !(
                            rowData.statuses[0].transactionStatus ===
                              "SALE_STARTED" ||
                            rowData.statuses[0].transactionStatus ===
                              "SALE_PENDING" ||
                            rowData.statuses[0].transactionStatus ===
                              "SALE_FAILED"
                          )
                        }
                      >
                        {" "}
                        Verify{" "}
                      </MTButton>
                    ),
                    onClick: (evt, rowData) =>
                      this.verifyTransactionStatus(rowData),
                    disabled:
                      !(
                        rowData.statuses[0].transactionStatus ===
                          "SALE_STARTED" ||
                        rowData.statuses[0].transactionStatus ===
                          "SALE_PENDING" ||
                        rowData.statuses[0].transactionStatus === "SALE_FAILED"
                      ) && this.state.verifying === false,
                  }),
                  (rowData) => ({
                    tooltip: "Refund transaction",
                    icon: (props) => (
                      <MTButton
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<ReverseIcon {...props} />}
                        disabled={
                          !(
                            rowData.statuses[0].transactionStatus ===
                              "SALE_SUCCESSFUL" ||
                            rowData.statuses[0].transactionStatus ===
                              "REFUND_FAILED"
                          )
                        }
                      >
                        {" "}
                        Refund{" "}
                      </MTButton>
                    ),
                    onClick: (evt, rowData) => this.showRefundPanel(rowData),
                    disabled: !(
                      rowData.statuses[0].transactionStatus ===
                        "SALE_SUCCESSFUL" ||
                      rowData.statuses[0].transactionStatus === "REFUND_FAILED"
                    ),
                  }),
                  (rowData) => ({
                    tooltip: "Change transaction Status",
                    icon: (props) => (
                      <MTButton
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<EditIcon {...props} />}
                      >
                        {" "}
                        Status{" "}
                      </MTButton>
                    ),
                    onClick: (evt, rowData) => this.showTxnUpdatePanel(rowData),
                  }),

                  (rowData) => ({
                    tooltip: "Dispute transaction",
                    icon: (props) => (
                      <MTButton
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<ThumbsUpDownIcon {...props} />}
                        disabled={
                          rowData.statuses[0].transactionStatus ===
                            "SALE_STARTED" ||
                          rowData.statuses[0].transactionStatus ===
                            "SALE_FAILED" ||
                          rowData.statuses[0].transactionStatus ===
                            "SALE_PENDING" ||
                          rowData.statuses[0].transactionStatus ===
                            "REFUND_FAILED" ||
                          rowData.statuses[0].transactionStatus ===
                            "REFUND_SUCCESSFUL" ||
                          rowData.statuses[0].transactionStatus ===
                            "CHARGEBACK" ||
                          rowData.statuses[0].transactionStatus === "SETTLED" ||
                          rowData.statuses[0].transactionStatus ===
                            "SALE_INIT" ||
                          rowData.isDisputeReported === "Y"
                        }
                      >
                        {" "}
                        Dispute{" "}
                      </MTButton>
                    ),
                    onClick: (evt, rowData) => this.showDisputePanel(rowData),
                    disabled:
                      rowData.statuses[0].transactionStatus ===
                        "SALE_STARTED" ||
                      rowData.statuses[0].transactionStatus === "SALE_FAILED" ||
                      rowData.statuses[0].transactionStatus ===
                        "SALE_PENDING" ||
                      rowData.statuses[0].transactionStatus ===
                        "REFUND_FAILED" ||
                      rowData.statuses[0].transactionStatus ===
                        "REFUND_SUCCESSFUL" ||
                      rowData.statuses[0].transactionStatus === "CHARGEBACK" ||
                      rowData.statuses[0].transactionStatus === "SETTLED" ||
                      rowData.statuses[0].transactionStatus === "SALE_INIT" ||
                      rowData.isDisputeReported === "Y",
                  }),
                ]}
                options={{
                  search: true,
                  exportButton: true,
                  exportCsv: (columns, data) => {
                    const acqIds = this.getAcquirerAccountIdToSubmit();
                    ApiService.fetchTransactionsXL(
                      format(this.state.fromDate, "yyyyMMdd"),
                      format(this.state.toDate, "yyyyMMdd"),
                      format(this.state.fromTime, "HH:mm:ss"),
                      format(this.state.toTime, "HH:mm:ss"),
                      this.state.statusCriteria,
                      this.state.orderNoCriteria,
                      this.state.email,
                      this.state.terminalId,
                      this.state.allChbk,
                      this.state.accountPoolId,
                      acqIds,
                      this.state.acquirerTxnId,
                      this.state.criteriaTxnId,
                      this.state.numberRowPerPage,
                      this.state.pageNumber
                    );
                  },
                  exportPdf: (columns, data) => {
                    const acqIds = this.getAcquirerAccountIdToSubmit();
                    ApiService.fetchTransactionsCSV(
                      format(this.state.fromDate, "yyyyMMdd"),
                      format(this.state.toDate, "yyyyMMdd"),
                      format(this.state.fromTime, "HH:mm:ss"),
                      format(this.state.toTime, "HH:mm:ss"),
                      this.state.statusCriteria,
                      this.state.orderNoCriteria,
                      this.state.email,
                      this.state.terminalId,
                      this.state.allChbk,
                      this.state.accountPoolId,
                      acqIds,
                      this.state.acquirerTxnId,
                      this.state.criteriaTxnId,
                      this.state.numberRowPerPage,
                      this.state.pageNumber
                    );
                  },
                  padding: "dense",
                  selection: false,
                  actionsColumnIndex: 12,
                  emptyRowsWhenPaging: false,
                  doubleHorizontalScroll: true,
                  initialPage: 0,
                  pageSize: this.state.numberRowPerPage,
                }}
                detailPanel={[
                  {
                    tooltip: "Show details",
                    render: (rowData) => {
                      return (
                        <Table size="small">
                          <TableHead>
                            <TableRow className={classes.detailhead}>
                              {this.headCells2.map((head) => (
                                <StyledTableCell key={head.id} align="left">
                                  {head.label}
                                </StyledTableCell>
                              ))}
                              {rowData.baseCurrency != null && (
                                <StyledTableCell
                                  align="left"
                                  numeric="false"
                                  disablePadding="false"
                                >
                                  Base Currency
                                </StyledTableCell>
                              )}
                              {rowData.baseAmount != null && (
                                <StyledTableCell
                                  align="left"
                                  numeric="true"
                                  disablePadding="false"
                                >
                                  Base Amount
                                </StyledTableCell>
                              )}
                              {this.headCells3.map((head) => (
                                <StyledTableCell key={head.id} align="left">
                                  {head.label}
                                </StyledTableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rowData.statuses.map((txn, index) => (
                              <TableRow>
                                <TableCell align="left">
                                  {format(
                                    new Date(txn.created),
                                    "dd MMM yyyy HH:mm:ss"
                                  )}
                                </TableCell>
                                <TableCell align="left">
                                  {txn.transactionStatus}
                                </TableCell>
                                {rowData.baseCurrency != null && (
                                  <TableCell align="left">
                                    {rowData.baseCurrency}
                                  </TableCell>
                                )}
                                {rowData.baseAmount != null && (
                                  <TableCell align="left">
                                    {rowData.baseAmount}
                                  </TableCell>
                                )}
                                <TableCell align="left">
                                  {rowData.capturedAmount &&
                                    rowData.capturedAmount}
                                </TableCell>
                                <TableCell align="left">
                                  {txn.transactionStatus === "CHARGEBACK" &&
                                    rowData.chargeBackAmount &&
                                    rowData.chargeBackAmount}
                                </TableCell>
                                <TableCell align="left">
                                  {txn.gatewayResponse[0] &&
                                    txn.gatewayResponse[0].billingDescriptor}
                                </TableCell>
                                <TableCell align="left">
                                  {txn.gatewayResponse[0] &&
                                    txn.gatewayResponse[0]
                                      .gatewayResponseTrackerId}
                                </TableCell>
                                <TableCell align="left">
                                  {txn.gatewayResponse[0] &&
                                    txn.gatewayResponse[0].txnInfo}
                                </TableCell>
                                <TableCell align="left">
                                  {txn.gatewayResponse[0] &&
                                    txn.gatewayResponse[0].signInfo}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      );
                    },
                  },
                ]}
              />
            </GridItem>
          </GridContainer>
          <Dialog
            open={this.state.refundPanelVisible}
            onClose={this.hideRefundPanel}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.hideRefundPanel}
            >
              Refund Transaction
            </DialogTitle>
            <DialogContent>
              <Grid>
                <Grid xs={12}>
                  <FormControl>
                    <Input
                      name="refundReason"
                      placeholder="Refund reason"
                      value={this.state.refundReason}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid xs={12}>
                  <FormControl>
                    <Input
                      name="refundAmount"
                      placeholder="Refund amount"
                      type="amount"
                      value={this.state.refundAmount}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid xs={12}>
                  <Box align="center" style={{ marginTop: "1em" }}>
                    <Button
                      onClick={this.refundTransaction}
                      variant="contained"
                      color="primary"
                    >
                      Refund{" "}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>

          <Dialog
            open={this.state.disputePanelVisible}
            onClose={this.hideDisputePanel}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.hideDisputePanel}
            >
              Dispute Transaction
            </DialogTitle>
            <DialogContent>
              <Grid>
                <Grid xs={12} style={{ marginBottom: "1em" }}>
                  <FormControl>
                    <Input
                      name="disputeInitiator"
                      placeholder="Dispute Initiator"
                      value={this.state.disputeInitiator}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid xs={12} style={{ marginBottom: "1em" }}>
                  <FormControl>
                    <Input
                      name="disputeInfo"
                      placeholder="Dispute Info"
                      value={this.state.disputeInfo}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                </Grid>

                <Grid xs={12}>
                  <FormControl>
                    <Input
                      name="disputeAmount"
                      placeholder="Dispute amount"
                      type="amount"
                      value={this.state.disputeAmount}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid xs={12}>
                  <Box align="center" style={{ marginTop: "1em" }}>
                    <Button
                      onClick={this.disputeTransaction}
                      variant="contained"
                      color="primary"
                    >
                      Submit{" "}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>

          <Dialog
            open={this.state.txnUpdatePanelVisible}
            onClose={this.hideTxnUpdatePanel}
          >
            <DialogTitle onClose={this.hideTxnUpdatePanel}>
              Change Transaction Status
            </DialogTitle>
            <DialogContent>
              <Grid>
                {this.state.failed2 && (
                  <Alert severity="error" elevation={0}>
                    {" "}
                    {this.state.responsemessage2}
                  </Alert>
                )}
                {this.state.success2 && (
                  <Alert severity="success" elevation={0}>
                    {" "}
                    {this.state.responsemessage2}
                  </Alert>
                )}

                <Grid xs={12}>
                  <InputLabel
                    style={{ marginTop: "1em" }}
                    id="targetSstatusLable"
                  >
                    Target status
                  </InputLabel>
                  <Select
                    value={this.state.targetStatus}
                    className={classes.formControl}
                    onChange={this.handleTargetStatusSelectChange}
                    labelId="targetSstatusLable"
                    id="statusSelect"
                  >
                    <MenuItem
                      key={"SALE_SUCCESSFUL"}
                      value={"SALE_SUCCESSFUL"}
                      dense
                    >
                      SALE_SUCCESSFUL
                    </MenuItem>
                    <MenuItem key={"SALE_FAILED"} value={"SALE_FAILED"} dense>
                      SALE_FAILED
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid xs={12}>
                  <TextField
                    name="gatewayResponseTrackerId"
                    label="Tracker Id"
                    value={this.state.gatewayResponseTrackerId}
                    onChange={this.handleChange}
                    className={classes.formControl}
                  />
                </Grid>
                <Grid xs={12}>
                  <TextField
                    name="transactionInfo"
                    label="Transaction Info"
                    value={this.state.transactionInfo}
                    onChange={this.handleChange}
                    className={classes.formControl}
                  />
                </Grid>
                <Grid xs={12}>
                  <TextField
                    name="billingDescriptor"
                    label="Billig descriptor"
                    value={this.state.billingDescriptor}
                    onChange={this.handleChange}
                    className={classes.formControl}
                  />
                </Grid>
                <Grid xs={12}>
                  <TextField
                    name="signInfo"
                    label="Sign Info"
                    value={this.state.signInfo}
                    onChange={this.handleChange}
                    className={classes.formControl}
                  />
                </Grid>

                <Grid xs={12}>
                  <FormControl className={classes.formControl}>
                    <InputLabel id="poolSelectLabel">Account Pool</InputLabel>
                    <Select
                      value={this.state.accountPoolIdNew}
                      MenuProps={this.MenuProps}
                      onChange={this.handleAccountPoolChangeNew}
                      name="accountPoolIdNew"
                      labelId="poolSelectLabel"
                      id="accountPoolIdSelect"
                    >
                      <MenuItem key="" value="">
                        All{" "}
                      </MenuItem>

                      {this.state.accountPoolIdList &&
                        this.state.accountPoolIdList.map((pool) => (
                          <MenuItem key={pool} value={pool} dense>
                            {pool}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid xs={12}>
                  <FormControl
                    className={classes.formControl1}
                    style={{ marginTop: "1em" }}
                  >
                    <Autocomplete
                      value={this.state.acquirerAccId}
                      onChange={this.handleAcquirerAccountChange2}
                      options={acquirerAccounts}
                      getOptionLabel={(option) =>
                        option
                          ? `${option.mid}-${option.accountNumber}-${option.userName}-${option.cardType?.type}`
                          : ""
                      }
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="AcquirerAccount"
                          placeholder="AcquirerAccount"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid xs={12}>
                  <Box align="center" style={{ marginTop: "1em" }}>
                    <Button
                      onClick={this.changeTransactionStatus}
                      variant="contained"
                      color="primary"
                    >
                      Change status{" "}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(MerchantTransactionsComponent);
